"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react"; // Optional: npm i lucide-react
import { motion } from "framer-motion";

const VideoHero2 = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden -mt-[96px] bg-black text-white font-sans">
      {/* 1. Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        className="absolute inset-0 h-full w-full object-cover opacity-60"
      >
        <source src="/images/hero-slideshow-vid-hq.mp4" type="video/mp4" />
      </video>

      {/* 2. Gradient Overlay for Text Legibility */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-[#0a1f51]/50" />

      {/* 3. Content Container */}
      <div className="relative z-10 flex h-full flex-col justify-end p-8 md:p-16 lg:p-24">
        {/* Top Section: Trust Indicators */}
        <motion.div
              initial={{ filter: "blur(10px)", opacity: 0 }}
              whileInView={{ filter: "blur(0px)", opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.7 }}
              className="text-4xl font-bold"
            >
          <div className="flex flex-col gap-2 mb-12">
            <div className="flex items-center gap-2 text-sm">
              <p>
                <span className="font-bold">Excellent 4.9 </span>
                out of 5
              </p>

              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <div
                    key={i}
                    className="h-4 w-4 bg-emerald-500 flex items-center justify-center"
                  >
                    <span className="text-[10px]">★</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-gray-300">
              <p className="text-sm md:text-base leading-relaxed text-gray-200">
                <span className="font-bold text-white">200+</span> lab tests.
                Detects early signs of <em className="italic">1,000+</em>{" "}
                conditions.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Bottom Section: Headlines and CTA */}
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          {/* Main Headline */}
          <div className="max-w-xl">
            <motion.div
              initial={{ filter: "blur(10px)", opacity: 0 }}
              whileInView={{ filter: "blur(0px)", opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <h1 className="text-6xl lg:text-8xl font-bold leading-[0.9] tracking-tighter">
                Feel Good.
                <br />
                Guided by
                <br />
                Science.
              </h1>
            </motion.div>
          </div>

          {/* CTA and Description */}
          <div className="max-w-md space-y-6 text-left">
            <motion.div
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }} // Only triggers the first time it enters view
              transition={{ type: "spring", stiffness: 100, delay: 0.3 }}
            >
              <p className="text-semibold md:text-xl leading-relaxed text-gray-200">
                Stop guessing and start{" "}
                <span className="font-bold text-white">thriving</span>. Unlock
                the data you need to look, feel, and perform at your{" "}
                <em className="italic">absolute best.</em>
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }} // Only triggers the first time it enters view
              transition={{ type: "spring", stiffness: 100, delay: 0.3 }}
            >
              <a href="/start" className="inline-flex group items-center justify-between w-full md:w-auto gap-4 rounded-full bg-cta-gradient px-8 py-4 text-sm font-bold uppercase tracking-widest text-white transition-transform hover:scale-105">
                Get Started Now
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-black transition-transform group-hover:rotate-45">
                  <ArrowUpRight size={18} />
                </div>
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoHero2;
